import { useCallback } from "react"
import { splitId } from "@components/content-feed/admin/manager"
import renderDetailLink from "@components/content-feed/util/renderDetailLink"

export default function useCommentsLoad(
  view_action,
  detailId,
  history,
  detail_asset_id,
  id,
  teaserId
) {
  return useCallback(
    view_action === "DETAIL" && detailId
      ? () => {
          history.push(
            renderDetailLink({
              detailId,
              assetId: detail_asset_id,
              itemId: splitId(id),
              teaserId: splitId(teaserId),
              anchor: "comments",
            }).substring(1)
          )
        }
      : undefined,
    [view_action, detailId, detail_asset_id, id]
  )
}
